import React from 'react';
import { workProcess } from '../data/mockData';

const HowWeWorkSection = () => {
  return (
    <section id="process" className="py-24 bg-[#F4F4F5]" data-testid="how-we-work-section">
      <div className="container mx-auto px-6 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-3">How It Works</p>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#09090B]" style={{fontFamily:'Outfit,sans-serif'}}>
            Three Steps. One Registered Trademark.
          </h2>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-3 gap-px bg-zinc-200 rounded-lg overflow-hidden">
            {workProcess.map((step) => (
              <div key={step.id} className="bento-hover bg-white p-8 relative" data-testid={`process-step-${step.id}`}>
                <span className="text-6xl font-black text-zinc-100 leading-none block mb-4" style={{fontFamily:'Outfit,sans-serif'}}>{step.step}</span>
                <h3 className="text-base font-bold text-[#09090B] mb-3" style={{fontFamily:'Outfit,sans-serif'}}>{step.title}</h3>
                <p className="text-sm text-zinc-500 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeWorkSection;
